import { useContext } from "react";
import {
  LanguageContext,
  LanguageContextType,
} from "@/application/contexts/LanguageContext";

/**
 * 語言 Hook
 * 提供對語言狀態和切換功能的訪問
 */
export function useLanguage(): LanguageContextType {
  const context = useContext(LanguageContext);

  if (context === undefined) {
    throw new Error("useLanguage 必須在 LanguageProvider 內部使用");
  }

  return context;
}
